import { CarFront, MapPinned } from "lucide-react";
import { googleMapsNavigationUrl, wazeNavigationUrl, type NavTarget } from "../navigation";

export function NavigateLinks({ target, label }: { target: NavTarget; label: string }) {
	return (
		<div className="navigate-links">
			<a
				className="navigate-link navigate-link--icon"
				href={wazeNavigationUrl(target)}
				target="_blank"
				rel="noreferrer"
				aria-label={`${label} with Waze`}
				title={`${label} with Waze`}
			>
				<CarFront size={22} strokeWidth={2} aria-hidden="true" />
			</a>
			<a
				className="navigate-link navigate-link--icon"
				href={googleMapsNavigationUrl(target)}
				target="_blank"
				rel="noreferrer"
				aria-label={`${label} with Google Maps`}
				title={`${label} with Google Maps`}
			>
				<MapPinned size={22} strokeWidth={2} aria-hidden="true" />
			</a>
		</div>
	);
}
